<template>
  <el-drawer :before-close="handleClose" :visible.sync="show" size="420px" :title="'诊所详细信息'">
    <div v-loading="loading" style="padding: 20px">
      <el-descriptions title="诊所信息" :column="1">
        <el-descriptions-item label="诊所微信二维码" v-if="wechatBindState">
          <el-button type="text" v-if="showQr" size="mini" style="padding:0" @click="() => this.showQr = !this.showQr">
            隐藏二维码
          </el-button>
          <el-button type="text" v-if="!showQr" size="mini" style="padding:0"
                     @click="() => this.showQr = !this.showQr">显示二维码
          </el-button>
          <div class="qr-div" v-show="showQr">
            <clinic-wechat-q-r v-if="!destroy" ref="clinicQr" :clinicCode="info.clinicCode"/>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="诊所微信二维码" v-else>
          <el-tag type="danger" size="mini">未绑定公众号</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="诊所">{{ info.clinicName }}</el-descriptions-item>
        <el-descriptions-item label="诊所编号">{{ info.clinicNumber }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag size="mini" v-if="info.enableState===0" disable-transitions type="danger">未审核</el-tag>
          <el-tag size="mini" v-else-if="info.enableState===1" disable-transitions type="success">已审核</el-tag>
        </el-descriptions-item>
        <el-descriptions-item v-if="this.tenantInfo.enableProduct === 1" label="产品">
        </el-descriptions-item>
        <el-descriptions-item v-if="this.tenantInfo.enableProduct === 1" labelStyle="display:none">
          <el-tag v-for="(e, index) in productName" :key="index" size="mini" type="primary">{{ e }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="地区">
          <span>{{ info.clinicAddress }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="详细地址">{{ info.clinicDetailAddress }}</el-descriptions-item>
        <el-descriptions-item label="药企">{{ info.operatorName }}</el-descriptions-item>
        <el-descriptions-item label="更新人">{{ info.updateUserName }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ info.updateTime }}</el-descriptions-item>
        <el-descriptions-item label="医生数量">{{ info.dockerNum }}</el-descriptions-item>
        <el-descriptions-item label="有效期始"><div>{{ info.startDate }}</div></el-descriptions-item>
        <el-descriptions-item label="有效期止">
          <div>{{ info.expiryDate }}
            <el-tag v-if="expiryState === 0" type="success" size="mini">有效</el-tag>
            <el-tag v-if="expiryState === 1" type="danger" size="mini">过期</el-tag></div>
        </el-descriptions-item>
        <el-descriptions-item label="资质证书"/>
        <el-descriptions-item label="" labelStyle="display:none">
          <div class="box">
            <div v-for="file in info.file" :key="file.uuid" class="box-item">
              <el-image
                :preview-src-list="[formatOssUrl(file.fileUrl)]"
                :src="formatOssUrl(file.fileUrl+process)"
                fit="cover"
                lazy
                style="width: 120px;height: 120px"/>
            </div>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
import {clinicInfo} from '@/api/business/clinic'
import area from '@/utils/area/data'
import ClinicWechatQR from '@/views/doctor/diagnosis/start/clinic-wechat-qr.vue'
import {mapGetters} from 'vuex'

export default {
  name: 'ShowClinicInfo',
  components: {ClinicWechatQR},
  computed: {
    ...mapGetters(['tenantInfo']),
    // 租户是否绑定了公众号
    wechatBindState() {
      return this.tenantInfo.wechatBindState === 1
    }
  },
  data() {
    return {
      showQr: true,
      destroy: false,
      loading: false,
      process: '?x-oss-process=image/resize,m_mfit,h_120,w_120',
      show: false,
      area: '',
      productCategoryList: [],
      productName: '',
      info: {
        tenantCode: '',
        clinicCode: '',
        clinicName: '',
        productCode: '',
        operatorCode: '',
        enableState: '',
        certificationUuids: '',
        clinicAddress: '',
        updateUserCode: '',
        updateTime: '',
        operatorName: '',
        updateUserName: '',
        file: [],
        dockerNum: '',
        expiryDate: ''
      },
      expiryState: -1
    }
  },
  created() {
    this.area = area
  },
  methods: {
    open(clinicCode) {
      this.loading = true
      this.info.clinicCode = clinicCode
      clinicInfo(clinicCode).then(({data}) => {
        this.loading = false
        if (data && data.code === 0) {
          this.info = data.data
          if (this.info.expiryDate) {
            if (Date.now() > Date.parse(this.info.expiryDate)) {
              // 过期
              this.expiryState = 1
            } else {
              // 未过期
              this.expiryState = 0
            }
          }
          if (data.data.productName) {
            this.productName = data.data.productName.split(',')
          }
        }
      })
      this.show = true
      this.destroy = false
    },
    handleClose(done) {
      this.info = {
        tenantCode: '',
        clinicCode: '',
        clinicName: '',
        productCode: '',
        operatorCode: '',
        enableState: '',
        certificationUuids: '',
        clinicAddress: '',
        updateUserCode: '',
        updateTime: '',
        operatorName: '',
        updateUserName: '',
        file: [],
        dockerNum: '',
        expiryDate: -1
      }
      this.productName = ''
      this.showQr = true
      this.destroy = true
      done()
    }
  }
}
</script>

<style scoped lang="scss">
.box {
  display: -webkit-flex; /* Safari */
  display: flex;
  flex-wrap: wrap;

  .box-item {
    padding: 8px;
  }
}

/deep/ .qr-div {
  position: absolute;
  top: 50px;
  right: 50px;

  .clinic-wechat-qr-wrap {
    position: relative;
    padding: 0;
  }

  .qrcode-title {
    padding: 0 0 10px 0;
  }

  .qrcode-description {
    padding: 10px 0 0 0;
  }
}

.el-tag {
  margin: 0 5px 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/showClinicInfo/index.vue